// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { Box, InputLabel, Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
// Components, Layouts, Pages
import { BaseSelect } from '~/components/common';
// Others
import { IBaseOption, IResultCallApiFn } from '~/utils/interface/common';
import { IFormOrder } from '~/utils/interface/order';
import { DateFormatEnum } from '~/utils/enum/common';
import { formatDate } from '~/utils/helper/common';
import { mockDataListTemplateOrder } from '~/utils/mockData/orders';
import { convertDataDetailOrdersForm } from '~/pages/common/order/orderForm/helper';
// Styles, images, icons
import styles from './TemplateOrderForm.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const TemplateOrderForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/order']);
  const { id: orderId } = useParams();

  const {
    control,
    watch,
    setValue,
    reset,
    formState: {},
  } = useFormContext<IFormOrder>();

  const { listOrderItems } = watch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo

  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const fetchOptions = useCallback(async (): Promise<IResultCallApiFn<IBaseOption>> => {
    const result: IResultCallApiFn<IBaseOption> = {
      optionsResp: mockDataListTemplateOrder,
      hasMoreResp: false,
    };

    return result;
  }, []);

  const handleSelectTemplate = (selectedValue: IBaseOption | null) => {
    // switch (selectedValue?.value) {
    //   case '1':
    //     const convertData: IFormOrder = convertDataDetailOrdersForm({} as any);
    //     const newData: IFormOrder = {
    //       ...convertData,
    //       listOrderItems,
    //       startTime: convertData.startTime ? formatDate(convertData.startTime, DateFormatEnum.HH_mm) : undefined,
    //       endTime: convertData.endTime ? formatDate(convertData.endTime, DateFormatEnum.HH_mm) : undefined,
    //       earliestDeliveryTime: convertData.earliestDeliveryTime
    //         ? formatDate(convertData.earliestDeliveryTime, DateFormatEnum.HH_mm)
    //         : undefined,
    //       latestPickupTime: convertData.latestPickupTime
    //         ? formatDate(convertData.latestPickupTime, DateFormatEnum.HH_mm)
    //         : undefined,
    //     };
    //     reset(newData);
    //     setValue('templateOrderId', selectedValue.value);
    //     break;
    //   case '2':
    //     reset();
    //     break;
    //   default:
    //     reset();
    //     break;
    // }
  };
  //#endregion Handle Function

  return (
    <Box id='templateOrderFormComponent' className={cx('container')}>
      <Stack direction={'column'} spacing={'10px'}>
        <InputLabel className={cx('label')}>{t('form_orders_label_template')}</InputLabel>

        <Controller
          name='templateOrderId'
          control={control}
          render={({ field: { onChange, value } }) => (
            <BaseSelect
              gap={8}
              width={'42%'}
              value={value}
              disabled={!!orderId}
              styleType='contained'
              placeholder={t('form_orders_placeholder_template')}
              callApiFn={fetchOptions}
              onChange={(selectedValue) => {
                handleSelectTemplate(selectedValue);
              }}
            />
          )}
        />
      </Stack>
    </Box>
  );
};

export default TemplateOrderForm;
